import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { IonicApp, IonicModule } from 'ionic-angular';
import { ConfigurationService } from 'ionic-configuration-service';

import { AppRoutingModule } from './app-routing.module';
import { ZeissVisionECP } from './app.component';

// Pages
import { VideoPage } from '../pages/video/video';
import { WelcomePage } from '../pages/welcome/welcome';
import { Slide1Page } from '../pages/slide1/slide1';
import { Slide2Page } from '../pages/slide2/slide2';
import { Slide3Page } from '../pages/slide3/slide3';
import { Slide4Page } from '../pages/slide4/slide4';
import { Slide5Page } from '../pages/slide5/slide5';
import { Slide6Page } from '../pages/slide6/slide6';
import { RecommendationPage } from '../pages/recommendation/recommendation';
import { SMSCustomerPage } from '../pages/sms-customer/sms-customer';
import { EmailCustomerPage } from '../pages/email-customer/email-customer';
import { AdminKeypadPage } from '../pages/admin-keypad/admin-keypad';
import { AdminSettingsPage } from '../pages/admin-settings/admin-settings';
import { SendSuccessPage } from '../pages/send-success/send-success';
import { ConfirmFinishPage } from '../pages/confirm-finish/confirm-finish';
import { GeneralErrorPage } from '../pages/error/general';
import { SMSTermsPage } from '../pages/sms-terms/sms-terms';

// Components
import { BulletProgressBarComponent } from '../components/bullet-progress-bar/bullet-progress-bar.component';
import { CNButtonComponent } from '../components/cn-button/cn-button.component';
import { ZeissPanelComponent } from '../components/zeiss-panel/zeiss-panel.component';
import { ZeissLogoComponent } from '../components/zeiss-logo/zeiss-logo.component';
import { EmailBodyComponent } from '../components/email-body/email-body.component';
import { NetworkLossComponent } from '../components/network-loss/network-loss.component';
import { CNCircularSliderComponent } from '../components/cn-circular-slider/cn-circular-slider.component';
import { PDFComponent } from '../components/pdf/pdf.component';
import { PDFHeaderComponent } from '../components/pdf-header/pdf-header.component';
import { PDFFooterComponent } from '../components/pdf-footer/pdf-footer.component';
import { PDFRecommendationComponent } from '../components/pdf-recommendation/pdf-recommendation.component';

// Services
import { AppInitService } from './app-init.service';
import { ErrorService } from '../services/error.service';
import { AdminService } from '../services/admin.service';
import { SessionService } from '../services/session.service';
import { NetworkStatusService } from '../services/network-status.service';
import { RecommendationService } from '../services/recommendation.service';
import { PDFService } from '../services/pdf.service';
import { UploadFileService } from '../services/upload-file.service';
import { RegionService } from '../services/region.service';
import { UtilityService } from '../services/utility.service';
import { TrackingService } from '../services/tracking.service';
import { GtagService } from '../services/gtag.service';

export function initApplication(appInitService: AppInitService): () => Promise<void> {
  return () => appInitService.init();
}

@NgModule({
  declarations: [
    ZeissVisionECP,
    VideoPage,
    WelcomePage,
    Slide1Page,
    Slide2Page,
    Slide3Page,
    Slide4Page,
    Slide5Page,
    Slide6Page,
    SMSCustomerPage,
    SMSTermsPage,
    EmailCustomerPage,
    AdminKeypadPage,
    SendSuccessPage,
    ConfirmFinishPage,
    RecommendationPage,
    AdminSettingsPage,
    GeneralErrorPage,
    ZeissLogoComponent,
    ZeissPanelComponent,
    CNCircularSliderComponent,
    EmailBodyComponent,
    NetworkLossComponent,
    CNButtonComponent,
    BulletProgressBarComponent,
    PDFComponent,
    PDFHeaderComponent,
    PDFFooterComponent,
    PDFRecommendationComponent,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(ZeissVisionECP, { mode: 'md' }),
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpModule,
    HttpClientModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    ZeissVisionECP,
    VideoPage,
    WelcomePage,
    Slide1Page,
    Slide2Page,
    Slide3Page,
    Slide4Page,
    Slide5Page,
    Slide6Page,
    SMSCustomerPage,
    SMSTermsPage,
    EmailCustomerPage,
    AdminKeypadPage,
    AdminSettingsPage,
    SendSuccessPage,
    ConfirmFinishPage,
    RecommendationPage,
    GeneralErrorPage,
  ],
  providers: [
    AdminService,
    NetworkStatusService,
    RegionService,
    ErrorService,
    PDFService,
    SessionService,
    RecommendationService,
    UploadFileService,
    UtilityService,
    GtagService,
    { provide: 'gtagConfig', useValue: { trackingId: 'G-Y2X50CEL9M', trackPageViews: true } },
    ConfigurationService,
    TrackingService,
    AppInitService,
    {
      provide: APP_INITIALIZER,
      useFactory: initApplication,
      deps: [AppInitService],
      multi: true,
    },
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts